export const extraStoreCreditTypes = {
  fixedAmount: 'fixed_amount',
  percentage: 'percentage',
  deliveryMethodFee: 'delivery_method_fee',
}

export const extraStoreCreditOptions = [
  {
    value: extraStoreCreditTypes.fixedAmount,
    label: 'Importe extra',
  },
  {
    value: extraStoreCreditTypes.percentage,
    label: 'Porcentaje extra',
  },
  {
    value: extraStoreCreditTypes.deliveryMethodFee,
    label: 'Bonificar coste de devolución',
  },
]

export const labelValuesByExtraStoreCreditOption = {
  [extraStoreCreditTypes.fixedAmount]: 'Importe extra',
  [extraStoreCreditTypes.percentage]: 'Porcentaje extra',
}
